import { SocialPostFragment } from '@graphql/fragments/__generated__/SocialPost.generated'
import Link from '@mui/material/Link'
import { svgIconClasses } from '@mui/material/SvgIcon'
import makeStyles from '@mui/styles/makeStyles'
import PlaceHolder from 'images/placeholder-img.svg'
import PlaceHolderImg from 'images/placeholder1080x1080.png'
import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { StringParam, useQueryParams } from 'use-query-params'
import { CLIENT_URL } from '../../constants'
import HalfCircleIcon from '../../icons/HalfCircleIcon'
import PostShareButtons from './DialogPost/PostShareButtons'

const useStyles = makeStyles(theme => ({
  wrapper: {
    boxShadow: '0px 0px 0px 1px #d8d8d8',
    '&:hover $imgWrapper': {
      height: '90%',
    },
    '&:hover $detailsWrapper': {
      '-webkit-transform': 'translateY(0%)',
      transform: 'translateY(0%)',
    },
  },
  imgWrapper: {
    height: '100%',
    transition: 'all 0.25s ease',
  },
  bottomSvg: {
    [`&.${svgIconClasses.root}`]: {
      zIndex: 3,
      height: 46,
      fill: '#fff',
      width: '100%',
      bottom: -1,
    },
  },
  detailsWrapper: {
    '-webkit-transform': 'translateY(100%)',
    transform: 'translateY(100%)',
    transition: 'all 0.25s ease',
  },
  socialLinks: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    top: 25,
    zIndex: 1,
  },
}))

interface PostProps {
  post: SocialPostFragment
}

const PostThumb: React.FC<PostProps> = ({ post }) => {
  const classes = useStyles()
  const [, setParams] = useQueryParams({
    postId: StringParam,
  })
  const shareBtnImgUrl = !!post.images?.length ? `${CLIENT_URL}${post.images[0].url}` : CLIENT_URL
  return (
    <div className={`relative cursor-pointer w-full h-full overflow-hidden ${classes.wrapper}`}>
      <div className={`relative w-full h-full ${classes.imgWrapper}`} onClick={() => setParams({ postId: post.id })}>
        <LazyLoadImage
          alt={post.name}
          effect='opacity'
          placeholderSrc={PlaceHolder}
          src={post.images.length > 0 ? post.images[0].thumbnailUrl : PlaceHolderImg}
          wrapperClassName='w-full h-full'
          className='w-full h-full object-cover object-center'
        />
      </div>
      <div className={`absolute bottom-0 h-80 w-full ${classes.detailsWrapper}`}>
        <HalfCircleIcon viewBox='0 -5 240 51' className={classes.bottomSvg} />
        <div className={classes.socialLinks}>
          <PostShareButtons
            url={window.location.href}
            imgUrl={shareBtnImgUrl}
            title={post?.name}
            description={post?.description || ''}
            hashtag={window.location.pathname}
            iconSize={20}
            dense
          />
        </div>
        <div className='w-full text-center bg-white absolute py-5' style={{ top: 43, bottom: 0 }}>
          {!!post.username && (
            <Link href={post.externalLink} target='_blank' className='block pt-5'>
              <span className='no-undeline'>@{post.username}</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default PostThumb
